import React from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/es/Field';
import { FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';
import InputField from 'components/Credit24/Core/Controls/InputField';
import AuthenticationErrorMessage from 'components/common/AuthenticationErrorMessage';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  navigateBackToLinkRequest: PropTypes.func.isRequired,
  recoveryEmail: PropTypes.string,
};

const RequestPasswordReset = (props) => {
  const { authentication } = props;

  if (authentication.isRecoveryEmailSent) {
    return (
      <div className="loan-form__step">
        <div className="loan-form__step-title loan-form__step-title--bottom-margin">
          <span className="icon icon--email-large" />
          <FormattedMessage id="password.recovery.success.title" tagName="h2" />
        </div>
        <div className="loan-form__step-body">
          <p className="txt-large">
            <FormattedMessage
              id="password.recovery.success.description"
              values={{
                email: <strong>{props.recoveryEmail}</strong>,
              }}
            />
          </p>
          <div className="txt-center">
            <button className="link link--pseudo">
              <FormattedMessage id="password.recovery.success.resend" />
            </button>
          </div>
        </div>
        <div className="loan-form__footer loan-form__footer--center">
          <Button btnType="secondary" type="button" onClick={props.navigateBackToLinkRequest}>
            <FormattedMessage id="password.recovery.success.back" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="loan-form__step">
      <div className="loan-form__step-title">
        <FormattedMessage id="password.recovery.title" tagName="h2" />
      </div>
      <div className="loan-form__step-body">
        <p className="txt-center">
          <FormattedMessage id="password.recovery.description" />
        </p>
        <AuthenticationErrorMessage authentication={authentication} />
        <Field
          title={<FormattedMessage id="password.recovery.field.email" />}
          name="recoveryEmail"
          type="text"
          component={InputField}
          isFullWidth
        />
      </div>
      <div className="loan-form__footer">
        <Button
          btnType="secondary"
          type="button"
          tag="link"
          to="login"
        >
          <FormattedMessage id="password.recovery.cancel" />
        </Button>
        <Button
          isLoading={authentication.isLoading}
          disabled={authentication.isLoading}
        >
          <FormattedMessage id="password.recovery.send_link" />
        </Button>
      </div>
    </div>
  );
};

RequestPasswordReset.propTypes = propTypes;

export default RequestPasswordReset;
